import React, { useState, useEffect } from 'react';
import { Sun, MoonStars } from '@phosphor-icons/react';
import { getTheme, setTheme, THEME_DAY, THEME_NIGHT } from '../utils/theme';

/**
 * Segmented Day | Night toggle. Lives under the user's name on the
 * dashboard. Click flips the theme everywhere instantly (CSS overrides
 * in `styles/day-theme.css` key off `html.theme-day`) and persists the
 * choice to localStorage so refreshes / re-installs remember.
 */
export const ThemeToggle = () => {
  const [theme, setLocalTheme] = useState(getTheme());

  // Re-sync if some other tab changed it.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'show_master_theme') setLocalTheme(getTheme());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const choose = (t) => {
    setTheme(t);
    setLocalTheme(t);
  };

  const isDay = theme === THEME_DAY;

  return (
    <div
      className="inline-flex items-center bg-[#161616] border border-[#262626] rounded-lg p-0.5 mt-2"
      data-testid="theme-toggle"
      role="group"
      aria-label="Day or Night theme"
    >
      <button
        type="button"
        onClick={() => choose(THEME_DAY)}
        aria-pressed={isDay}
        data-testid="theme-toggle-day"
        className={`theme-toggle-btn flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[11px] font-bold ${
          isDay
            ? 'bg-[#FF9500] text-white shadow-sm'
            : 'text-[#9E9E9E] hover:text-white'
        }`}
      >
        <Sun size={13} weight={isDay ? 'fill' : 'duotone'} />
        Day
      </button>
      <button
        type="button"
        onClick={() => choose(THEME_NIGHT)}
        aria-pressed={!isDay}
        data-testid="theme-toggle-night"
        className={`theme-toggle-btn flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[11px] font-bold ${
          !isDay
            ? 'bg-[#0096FF] text-white shadow-sm'
            : 'text-[#9E9E9E] hover:text-white'
        }`}
      >
        <MoonStars size={13} weight={!isDay ? 'fill' : 'duotone'} />
        Night
      </button>
    </div>
  );
};

export default ThemeToggle;
